export default {"src":"/_next/static/media/icon-copy.5a3377a4.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};